export default "__VITE_ASSET__Vpiy4R7H__"